module.exports = __webpack_public_path__ + "static/index/img/baikal-300.b8936b54.jpg";